import { updateUserDocument } from 'services/server/data';

async function updateRemoteUserDocument(collection, updates, forceCreate) {
  await updateUserDocument(collection, updates, forceCreate);

  return { ...updates };
}

export default updateRemoteUserDocument;
